import { render, staticRenderFns } from "./ProximasPartidas.vue?vue&type=template&id=2f4a4850&scoped=true&"
import script from "./ProximasPartidas.vue?vue&type=script&lang=js&"
export * from "./ProximasPartidas.vue?vue&type=script&lang=js&"
import style0 from "./ProximasPartidas.vue?vue&type=style&index=0&id=2f4a4850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a4850",
  null
  
)

export default component.exports